const shoppingCartOpenReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_SHOPPING_CART_OPEN':
            return !state;
        default:
            return state;
    }
}

export default shoppingCartOpenReducer;